// src/store/specialtiesStore.js
import { create } from 'zustand';
import { getSpecialties } from '../api/providerApi';

const useSpecialtiesStore = create((set, get) => ({
    specialties: [],
    loading: false,
    error: null,

    fetchSpecialties: async () => {
        set({ loading: true, error: null });
        try {
            const data = await getSpecialties();
            set({ specialties: data, loading: false });
        } catch (err) {
            set({
                error: err.message || 'Failed to load specialties',
                loading: false,
            });
        }
    },

    // ✅ NO hard coding anymore
    getSpecialityNameById: (id) => {
        const speciality = get().specialties.find(
            (s) => s.MedicalSpecialities_ID === Number(id)
        );
        return speciality?.SpecialitiesName || `Speciality #${id}`;
    },
}));

export default useSpecialtiesStore;
